import React from 'react';

type SwipeEventProps = {
    className?: string;
    onSwipeLeft?: () => void;
    onSwipeRight?: () => void;
    onSwipeUp?: () => void;
    onSwipeDown?: () => void;
} & Props;

type PointType = {
    x: number;
    y: number;
};

const SwipeEvent: React.FC<SwipeEventProps> = (props: SwipeEventProps) => {
    const { className, onSwipeLeft, onSwipeRight, onSwipeUp, onSwipeDown } = props;
    let startPoint: PointType;
    let endPoint: PointType;
    let timer: any;
    let time = 0;

    const onTouchStart = e => {
        props.onTouchStart && props.onTouchStart(e);
        // 仅一个手指
        if (e.touches.length === 1) {
            startPoint = {
                x: e.touches[0].pageX,
                y: e.touches[0].pageY,
            };
            timer = setInterval(() => {
                time++;
            }, 10);
        }
    };
    const onTouchMove = e => {
        props.onTouchMove && props.onTouchMove(e);
        endPoint = {
            x: e.touches[0].pageX,
            y: e.touches[0].pageY,
        };
    };
    const onTouchEnd = e => {
        props.onTouchEnd && props.onTouchEnd(e);
        /*
         * 检查1S事件以内，比较滑动绝对值 x > y 即为水平滑动
         * 滑动超过40个坐标确定为滑动事件
         */
        // 1S以内 && 坐标均存在
        if (time < 100 && startPoint && endPoint) {
            let moveX = endPoint.x - startPoint.x;
            let moveY = endPoint.y - startPoint.y;
            // 水平移动
            if (Math.abs(moveX) > Math.abs(moveY)) {
                // 右滑
                if (moveX > 40) {
                    onSwipeRight && onSwipeRight();
                }
                // 左滑
                if (moveX < -40) {
                    onSwipeLeft && onSwipeLeft();
                }
            }
            // 垂直移动
            else {
                // 下滑
                if (moveY > 40) {
                    onSwipeDown && onSwipeDown();
                }
                // 上滑
                if (moveY < -40) {
                    onSwipeUp && onSwipeUp();
                }
            }
        }
        timer && clearInterval(timer);
        time = 0;
    };

    return (
        <div className={`touch ${className}`} onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>
            {props.children}
        </div>
    );
};

export default SwipeEvent;
